const LABELS = {
  "official-specification": "Official specification",
  "official-announcement": "Official announcement",
  "customer-confirmed": "Customer confirmed",
  "regulatory-document": "Regulatory document",
  "scientific-paper": "Scientific paper",
  "third-party-report": "Third-party report",
  "video-observation": "Video observation",
  "not-disclosed": "Not disclosed",
};

export default function ChartEvidenceBadge({ status = "not-disclosed" }) {
  return (
    <span className="inline-flex rounded-full border border-neutral-200 bg-neutral-50 px-2.5 py-1 text-[11px] font-black uppercase tracking-[0.12em] text-neutral-600">
      {LABELS[status] || status}
    </span>
  );
}
